export const ADMIN_USERS_PAGE_SIZE = 25;

/**
 * Browse request for listAdminUsers. Never includes filter cursors.
 * @param {{ pageSize?: number, pageToken?: string | null }} [params]
 */
export function buildBrowseRequest({ pageSize = ADMIN_USERS_PAGE_SIZE, pageToken } = {}) {
  const size = Number(pageSize);
  const request = {
    mode: 'browse',
    pageSize: Number.isFinite(size) && size > 0 ? Math.floor(size) : ADMIN_USERS_PAGE_SIZE,
  };
  if (pageToken) request.pageToken = String(pageToken);
  return request;
}

/**
 * Lookup request: email if the query contains "@", otherwise UID.
 * Same convention as ImpersonatePage. Never paginates.
 * @param {string} query
 */
export function buildLookupRequest(query) {
  const q = String(query || '').trim();
  if (q.includes('@')) return { mode: 'lookup', email: q };
  return { mode: 'lookup', uid: q };
}
